// Import necessary modules and hooks from React and React Router
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "../../../contexts/AuthContext";
import { useEffect, useState } from "react";

export const ProtectedRoute = ({ redirectPath = '/login' }) => {
    const { user, checkToken, zones } = useAuthContext();

    const [token, setToken] = useState(localStorage.getItem('unified_nova_accessToken'));

    useEffect(()=> {
        if(token){
            checkToken(); // Call the function to check the token
        }
    }, [])

    useEffect(()=> {
        if(!localStorage.getItem('unified_nova_accessToken')){
            setToken(null);
        }
    }, [user]);

    if (!token) {
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />
};